import React, { useState, useEffect } from "react";
import styles from "./HeaderDropDownMobile.module.scss";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../hooks/hook";
import { RootState } from "../../../redux/store";
import { ReactComponent as ArrowIcon } from "../../../assets/images/header/icons/arrow.svg";
import { ReactComponent as BackIcon } from "../../../assets/images/header/icons/back.svg";

interface HeaderDropdownProps {
  activeCategory: any[];
  onClick?: () => void;
  path: string;
  isMobileDropdownOpen: boolean;
  setMobileNavbar: (value: boolean) => void;
  translations?: any;
}

const HeaderDropDownMobile: React.FC<HeaderDropdownProps> = ({
  activeCategory,
  onClick,
  path,
  isMobileDropdownOpen,
  setMobileNavbar,
  translations,
}) => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState<any>(null);
  const theme = useAppSelector((state: RootState) => state.theme.mode);

  useEffect(() => {
    setCurrentStep(1);
    setSelectedCategory(null);
    setSelectedSubCategory(null);
  }, [path, isMobileDropdownOpen]);

  const handleBackClick = () => {
    if (currentStep === 3) {
      setCurrentStep(2);
      setSelectedSubCategory(null);
    } else if (currentStep === 2) {
      setCurrentStep(1);
      setSelectedCategory(null);
    }
  };

  const handleItemSelect = () => {
    setMobileNavbar(false);
  };

  const renderProducts = () => (
    <>
      {/* 1-ci MƏRHƏLƏ: Əsas Kateqoriyalar */}
      {currentStep === 1 && (
        <ul className={styles.category_items}>
          {activeCategory.map((category) => {
            const hasChildren =
              Array.isArray(category.children) && category.children.length > 0;

            return (
              <li
                key={category.id}
                className={
                  theme === "dark"
                    ? styles.dropdown_category_dark
                    : styles.dropdown_category
                }
                onClick={() => {
                  if (hasChildren) {
                    setSelectedCategory(category);
                    setCurrentStep(2);
                  } else {
                    handleItemSelect();
                    navigate(`/products/${category.slug || category.id}`);
                  }
                }}
              >
                <div className={styles.category_main}>
                  {category.image_url && (
                    <img
                      src={category.image_url}
                      alt=""
                      className={styles.categoryIcon}
                    />
                  )}
                  {hasChildren ? (
                    <span className={styles.category_name}>{category.name}</span>
                  ) : (
                    <Link
                      to={`/products/${category.slug || category.id}`}
                      className={styles.category_name}
                      onClick={handleItemSelect}
                    >
                      {category.name}
                    </Link>
                  )}
                </div>
                {hasChildren && (
                  <ArrowIcon
                    className={
                      theme === "dark" ? styles.iconDark : styles.iconLight
                    }
                  />
                )}
              </li>
            );
          })}
        </ul>
      )}

      {/* 2-ci MƏRHƏLƏ: Seçilmiş kateqoriyanın alt kateqoriyaları */}
      {currentStep === 2 && selectedCategory && (
        <>
          <div className={styles.stepHeader}>
            <button
              type="button"
              className={styles.backButton}
              onClick={handleBackClick}
              aria-label="Geri"
            >
              <BackIcon className={styles.iconBack} />
              <span>Geri</span>
            </button>
            <h4 className={styles.currentTitle}>{selectedCategory.name}</h4>
          </div>

          <Link
            to={`/products/${selectedCategory.slug || selectedCategory.id}`}
            className={styles.viewAllBtn}
            onClick={handleItemSelect}
          >
            <span>Bütün {selectedCategory.name}</span>
            <ArrowIcon className={styles.viewAllIcon} />
          </Link>

          <ul className={styles.category_items}>
            {selectedCategory.children?.map((subCategory: any) => {
              const hasSubChildren =
                Array.isArray(subCategory.children) &&
                subCategory.children.length > 0;

              return (
                <li
                  key={subCategory.id}
                  className={
                    theme === "dark"
                      ? styles.dropdown_category_dark
                      : styles.dropdown_category
                  }
                  onClick={() => {
                    if (hasSubChildren) {
                      setSelectedSubCategory(subCategory);
                      setCurrentStep(3);
                    } else {
                      handleItemSelect();
                      navigate(`/products/${subCategory.slug || subCategory.id}`);
                    }
                  }}
                >
                  <div className={styles.category_main}>
                    {hasSubChildren ? (
                      <span className={styles.category_name}>
                        {subCategory.name}
                      </span>
                    ) : (
                      <Link
                        to={`/products/${subCategory.slug || subCategory.id}`}
                        className={styles.category_name}
                        onClick={handleItemSelect}
                      >
                        {subCategory.name}
                      </Link>
                    )}
                  </div>
                  {hasSubChildren && (
                    <ArrowIcon
                      className={
                        theme === "dark" ? styles.iconDark : styles.iconLight
                      }
                    />
                  )}
                </li>
              );
            })}
          </ul>
        </>
      )}

      {/* 3-cü MƏRHƏLƏ: Seçilmiş alt kateqoriyanın məhsul növləri */}
      {currentStep === 3 && selectedSubCategory && (
        <>
          <div className={styles.stepHeader}>
            <button
              type="button"
              className={styles.backButton}
              onClick={handleBackClick}
              aria-label="Geri"
            >
              <BackIcon className={styles.iconBack} />
              <span>Geri</span>
            </button>
            <h4 className={styles.currentTitle}>{selectedSubCategory.name}</h4>
          </div>

          <Link
            to={`/products/${selectedSubCategory.slug || selectedSubCategory.id}`}
            className={styles.viewAllBtn}
            onClick={handleItemSelect}
          >
            <span>Bütün {selectedSubCategory.name}</span>
            <ArrowIcon className={styles.viewAllIcon} />
          </Link>

          <ul className={styles.category_items}>
            {selectedSubCategory.children?.map((item: any) => {
              const hasItemChildren =
                Array.isArray(item.children) && item.children.length > 0;

              return (
                <li key={item.id}>
                  <NavLink
                    to={`/products/${item.slug || item.id}`}
                    className={styles.leaf_item}
                    onClick={handleItemSelect}
                  >
                    <span>{item.name}</span>
                    {hasItemChildren && (
                      <ArrowIcon
                        className={
                          theme === "dark" ? styles.iconDark : styles.iconLight
                        }
                      />
                    )}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </>
      )}
    </>
  );

  const renderServices = () => (
    <>
      {currentStep === 1 && (
        <ul className={styles.category_items}>
          {activeCategory.map((serviceGroup) => (
            <li
              key={serviceGroup.id}
              className={
                theme === "dark"
                  ? styles.dropdown_category_dark
                  : styles.dropdown_category
              }
              onClick={() => {
                setSelectedCategory(serviceGroup);
                setCurrentStep(2);
              }}
            >
              <div className={styles.category_main}>
                <span className={styles.category_name}>{serviceGroup.name}</span>
              </div>
              <ArrowIcon
                className={
                  theme === "dark" ? styles.iconDark : styles.iconLight
                }
              />
            </li>
          ))}
        </ul>
      )}

      {currentStep === 2 && selectedCategory && (
        <>
          <div className={styles.stepHeader}>
            <button
              type="button"
              className={styles.backButton}
              onClick={handleBackClick}
              aria-label="Geri"
            >
              <BackIcon className={styles.iconBack} />
              <span>Geri</span>
            </button>
            <h4 className={styles.currentTitle}>
              {selectedCategory.name || translations?.services}
            </h4>
          </div>
          <ul className={styles.category_items}>
            {selectedCategory.services?.map((service: any) => (
              <li key={service.id}>
                <NavLink
                  to={
                    selectedCategory.name === "Təmir" ||
                    selectedCategory.id === 25
                      ? "/repair"
                      : "/install"
                  }
                  className={styles.leaf_item}
                  onClick={handleItemSelect}
                >
                  <span>{service.name}</span>
                  <ArrowIcon
                    className={
                      theme === "dark" ? styles.iconDark : styles.iconLight
                    }
                  />
                </NavLink>
              </li>
            ))}
          </ul>
        </>
      )}
    </>
  );

  const renderOtherPages = () => (
    <ul className={styles.category_items}>
      <li>
        <NavLink
          to="/campaigns"
          className={styles.leaf_item}
          onClick={handleItemSelect}
        >
          <span>{translations?.campaigns || "Kampaniyalar"}</span>
          <ArrowIcon
            className={theme === "dark" ? styles.iconDark : styles.iconLight}
          />
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/about"
          className={styles.leaf_item}
          onClick={handleItemSelect}
        >
          <span>{translations?.about_us || "Haqqımızda"}</span>
          <ArrowIcon
            className={theme === "dark" ? styles.iconDark : styles.iconLight}
          />
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/contact"
          className={styles.leaf_item}
          onClick={handleItemSelect}
        >
          <span>{translations?.contact || "Əlaqə"}</span>
          <ArrowIcon
            className={theme === "dark" ? styles.iconDark : styles.iconLight}
          />
        </NavLink>
      </li>
    </ul>
  );

  return (
    <div className={styles.mobile_dropdown} onClick={onClick}>
      <div className={styles.dropdown_content}>
        {path === "products" && renderProducts()}
        {path === "services" && renderServices()}
        {path === "others" && renderOtherPages()}
      </div>
    </div>
  );
};

export default HeaderDropDownMobile;
